export const CREATE_PLANOGRAMGROUP_PROCESSING =
    'CREATE_PLANOGRAMGROUP_PROCESSING';
export const PLANOGRAMGROUP_CREATE_SUCCESS = 'PLANOGRAMGROUP_CREATE_SUCCESS';
export const CREATE_PLANOGRAMGROUP_INIT = 'CREATE_PLANOGRAMGROUP_INIT';
export const CREATE_PLANOGRAMGROUP_GET_SUCCESS =
    'CREATE_PLANOGRAMGROUP_GET_SUCCESS';
export const CREATE_PLANOGRAM_LOADING = 'CREATE_PLANOGRAM_LOADING';
export const CREATE_PLANOGRAM_LOADING_DONE = 'CREATE_PLANOGRAM_LOADING_DONE';

export const initPlanogram = () => {
    return async (dispatch) => {
        dispatch({ type: CREATE_PLANOGRAMGROUP_INIT });
    };
};
